import { useState } from "react";
import { Play } from "lucide-react";
import { useTranslation } from "react-i18next";
import NewMatchFlow from "./NewMatchFlow";
import "./NewMatch.css";

// Global "New match" entry point for the nav. Opens a modal wrapping the shared
// NewMatchFlow. Mounted (and route/state-gated) by AppLayout — see there for
// where it's shown. A created team is playable, so no readiness gate here.
export default function NewMatchButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="newmatch-btn" onClick={() => setOpen(true)} title={t("nav.newMatch")}>
        <Play size={16} />
        <span className="newmatch-btn-label">{t("nav.newMatch")}</span>
      </button>

      {open && (
        <div className="newmatch-backdrop" onClick={() => setOpen(false)}>
          <div className="newmatch-modal" onClick={(e) => e.stopPropagation()}>
            <button className="newmatch-close" onClick={() => setOpen(false)} aria-label={t("dashboard.cancel")}>✕</button>
            <NewMatchFlow onLaunched={() => setOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
}
